import './Landingpage.scss';

import profil1 from 'assets/images/landingpage/profil_1.png';
import profil2 from 'assets/images/landingpage/profil_2.png';
import profil3 from 'assets/images/landingpage/profil_3.png';
import profil4 from 'assets/images/landingpage/profil_4.png';
import profil5 from 'assets/images/landingpage/profil_5.png';
import profil6 from 'assets/images/landingpage/profil_6.png';
import profil7 from 'assets/images/landingpage/profil_7.png';
import profil8 from 'assets/images/landingpage/profil_8.png';
import logoWithWriting from 'assets/images/logos/logo-with-writing.svg';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import {
    Button,
    CircularProgress,
    Dialog,
    IconButton,
    ThemeProvider,
    Typography,
    createTheme,
} from '@mui/material';
import { deDE } from '@mui/material/locale';
import React, { useMemo, useState } from 'react';
import { Link, Redirect, Route, useHistory } from 'react-router-dom';

import ForgotPasswordModal from 'components/ForgotPasswordModal';
import ForgotPasswordModalx from 'components/ForgotPasswordModalx';
import LoginModal from 'components/NewRegister/Login';
import SignInComponent from 'components/SignInComponent';
import Config from 'config';
import FBLoginButton from 'services/Facebook/FBLoginButton';
import useLoginHandler from 'services/Facebook/useLoginHandler';
import GoogleLoginButton from 'services/Google/GoogleLoginButton';
import useGoogleLoginHandler from 'services/Google/useGoogleLoginHandler';
import { FORGOT_PASSWORD_PATH, FORGOT_PASSWORD_PATHH, LOGIN_PATH, MAIN_PATH, REGISTER_PATH, REGISTER_USER } from '../../models/Paths';
import { DefaultTheme } from '../../theme/DefaultTheme';

export interface ILandingpageProps {}

type HighlightItem = {
    icon: React.ReactNode;
    label: string;
    tone: 'mint' | 'warm' | 'violet';
};

type FeatureItem = {
    icon: React.ReactNode;
    title: string;
    description: string;
};

type AvatarItem = {
    image: string;
    alt: string;
};

const heroHighlights: HighlightItem[] = [
    {
        icon: <VerifiedRoundedIcon />,
        label: '+25.000 aktive Nutzer',
        tone: 'mint',
    },
    {
        icon: <LocalFireDepartmentRoundedIcon />,
        label: 'Täglich neue Matches',
        tone: 'warm',
    },
    {
        icon: <ShieldRoundedIcon />,
        label: 'Sicher & anonym',
        tone: 'violet',
    },
];

const avatarItems: AvatarItem[] = [
    { image: profil1, alt: 'Happy Match' },
    { image: profil2, alt: 'App Lifestyle' },
    { image: profil3, alt: 'Romantic Evening' },
    { image: profil4, alt: 'Couple at Sunset' },
    { image: profil5, alt: 'Warm Portrait' },
    { image: profil6, alt: 'Dating App Preview' },
];

const featureItems: FeatureItem[] = [
    {
        icon: <PlaceRoundedIcon />,
        title: 'Singles in deiner Nähe',
        description: 'Finde passende Singles aus deiner Umgebung und entdecke Menschen, die wirklich zu dir passen.',
    },
    {
        icon: <VerifiedRoundedIcon />,
        title: 'Verifizierte Profile',
        description: 'Profile werden geprüft, damit du entspannter schreiben, matchen und neue Kontakte knüpfen kannst.',
    },
    {
        icon: <ShieldRoundedIcon />,
        title: 'Sicherheit & Anonymität',
        description: 'Deine Privatsphäre bleibt geschützt, während du diskret und sicher neue Leute kennenlernst.',
    },
];

export const Landingpage = React.memo(() => {
    const history = useHistory();
    const [socialLoading, setSocialLoading] = useState(false);
    const handleFBLogin = useLoginHandler();
    const handleGoogleLogin = useGoogleLoginHandler();

    const brandName = useMemo(() => Config.GLOBAL_SITE_NAME.toLowerCase(), []);
    const rootStyle = useMemo(
        () =>
            ({
                '--lp-primary': Config.GLOBAL_PRIMARY_COLOR,
                '--lp-primary-strong': '#d94a84',
                '--lp-accent': '#8b5cf6',
                '--lp-ink': '#34264f',
                '--lp-soft-ink': '#5d4d7a',
            }) as React.CSSProperties,
        []
    );

    return (
        <ThemeProvider theme={createTheme(DefaultTheme, deDE)}>
            <div className="landingpage" style={rootStyle}>
                <div className="landingpage__glow landingpage__glow--left" />
                <div className="landingpage__glow landingpage__glow--right" />
                <div className="landingpage__glow landingpage__glow--bottom" />

                <header className="landingpage__nav-wrap">
                    <div className="landingpage__shell landingpage__nav">
                        <Link to={MAIN_PATH} className="landingpage__brand" aria-label={`${Config.GLOBAL_SITE_NAME} Startseite`}>
                            <img src={logoWithWriting} alt={Config.GLOBAL_SITE_NAME} className="landingpage__brand-logo" />
                        </Link>

                        <div className="landingpage__nav-actions">
                            <Button
                                className="landingpage__ghost-button"
                                onClick={() => {
                                    history.push(LOGIN_PATH);
                                }}
                            >
                                Einloggen
                            </Button>
                            <Button
                                variant="contained"
                                className="landingpage__primary-button landingpage__nav-cta"
                                onClick={() => {
                                    history.push(REGISTER_USER);
                                }}
                            >
                                Jetzt registrieren
                            </Button>
                        </div>
                    </div>
                </header>

                <main>
                    <section className="landingpage__hero">
                        <div className="landingpage__shell landingpage__hero-grid">
                            <div className="landingpage__hero-copy">

                                <Typography component="h1" className="landingpage__hero-title">
                                    Finde echte Verbindungen.
                                </Typography>

                                <Typography component="p" className="landingpage__hero-text">
                                    Lerne Menschen kennen, die wirklich zu dir passen. Modern, sicher und mit Fokus auf echte Dates statt endlosem Swipen.
                                </Typography>

                                <div className="landingpage__highlight-list">
                                    {heroHighlights.map((item) => (
                                        <div key={item.label} className={`landingpage__highlight landingpage__highlight--${item.tone}`}>
                                            <span className="landingpage__highlight-icon">{item.icon}</span>
                                            <span>{item.label}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="landingpage__mobile-social-auth">
                                    <div className="landingpage__social-button">
                                        <GoogleLoginButton setLoading={setSocialLoading} onLoginFinished={handleGoogleLogin} />
                                    </div>

                                    <div className="landingpage__social-button">
                                        <FBLoginButton setLoading={setSocialLoading} onLoginFinished={handleFBLogin} />
                                    </div>
                                </div>
                            </div>

                            <div className="landingpage__hero-visual" aria-hidden="true">
                                <article className="landingpage__preview-card landingpage__preview-card--left">
                                    <div className="landingpage__preview-badge">Romantik</div>
                                    <img src={profil7} alt="" />
                                    <div className="landingpage__preview-meta">
                                        <strong>Mia, 26</strong>
                                        <span>Düsseldorf, DE</span>
                                    </div>
                                </article>

                                <article className="landingpage__preview-card landingpage__preview-card--center">
                                    <div className="landingpage__preview-badge">Date Night</div>
                                    <img src={profil8} alt="" />
                                    <div className="landingpage__preview-meta">
                                        <strong>Leon, 29</strong>
                                        <span>Köln</span>
                                    </div>
                                </article>

                                <article className="landingpage__signup-card">
                                    <div className="landingpage__signup-hero">
                                        <img src={profil2} alt="Glückliches Paar bei einem Date" />
                                        <div className="landingpage__signup-pill">
                                            <FavoriteRoundedIcon />
                                            <span>Neu!</span>
                                        </div>
                                    </div>

                                    <div className="landingpage__signup-body">
                                        <Typography component="h2" className="landingpage__signup-title">
                                            Jetzt registrieren
                                        </Typography>
                                        <Typography component="p" className="landingpage__signup-text">
                                            Kostenlos anmelden und Matches aus deiner Nähe finden.
                                        </Typography>

                                        <Button
                                            variant="contained"
                                            startIcon={<EmailRoundedIcon />}
                                            className="landingpage__primary-button landingpage__cta-button"
                                            onClick={() => {
                                                history.push(REGISTER_USER);
                                            }}
                                        >
                                            Weiter mit E-Mail
                                        </Button>

                                        <div className="landingpage__social-button">
                                            <GoogleLoginButton setLoading={setSocialLoading} onLoginFinished={handleGoogleLogin} />
                                        </div>

                                        <div className="landingpage__social-button">
                                            <FBLoginButton setLoading={setSocialLoading} onLoginFinished={handleFBLogin} />
                                        </div>

                                        <button
                                            type="button"
                                            className="landingpage__login-link"
                                            onClick={() => {
                                                history.push(LOGIN_PATH);
                                            }}
                                        >
                                            Schon Mitglied? Hier einloggen
                                        </button>

                                        {socialLoading && (
                                            <div className="landingpage__loading">
                                                <CircularProgress size={18} thickness={5} />
                                                <span>Anmeldung wird vorbereitet ...</span>
                                            </div>
                                        )}
                                    </div>
                                </article>

                                <article className="landingpage__preview-stack">
                                    <div className="landingpage__preview-stack-track">
                                        {[profil4, profil5, profil6].map((image) => (
                                            <img key={image} src={image} alt="" />
                                        ))}
                                    </div>
                                </article>
                            </div>
                        </div>
                    </section>

                    <section className="landingpage__section landingpage__section--testimonial">
                        <div className="landingpage__shell">
                            <Typography component="h2" className="landingpage__section-title">
                                Erfahrungen mit <span>{brandName}</span>
                            </Typography>

                            <div className="landingpage__avatar-row landingpage__avatar-row--spaced">
                                {avatarItems.map((item, index) => (
                                    <div
                                        key={`${item.alt}-${index}`}
                                        className={`landingpage__avatar ${index === 2 ? 'landingpage__avatar--active' : ''}`}
                                    >
                                        <img src={item.image} alt={item.alt} />
                                    </div>
                                ))}
                            </div>

                            <div className="landingpage__testimonial-card">
                                <Typography component="h3" className="landingpage__testimonial-name">
                                    Katarina S.
                                </Typography>
                                <Typography component="p" className="landingpage__testimonial-role">
                                    Verifizierte Nutzerin
                                </Typography>

                                <div className="landingpage__stars" aria-label="5 von 5 Sternen">
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <StarRoundedIcon key={index} />
                                    ))}
                                </div>

                                <Typography component="blockquote" className="landingpage__testimonial-quote">
                                    Dank {brandName} habe ich die große Liebe gefunden. Die App macht Spaß, ist einfach zu bedienen und ich fühle mich
                                    sicher und gut aufgehoben. <span>#LoveStory #Matches</span>
                                </Typography>

                                <Typography component="strong" className="landingpage__testimonial-name landingpage__testimonial-name--bottom">
                                    Katarina S.
                                </Typography>
                                <Typography component="p" className="landingpage__testimonial-role">
                                    Verifizierte Nutzerin
                                </Typography>
                            </div>
                        </div>
                    </section>

                    <section className="landingpage__section landingpage__section--benefits">
                        <div className="landingpage__shell">
                            <div className="landingpage__avatar-row">
                                {avatarItems.slice(0, 5).map((item, index) => (
                                    <div key={`${item.alt}-benefit-${index}`} className="landingpage__avatar landingpage__avatar--compact">
                                        <img src={item.image} alt={item.alt} />
                                    </div>
                                ))}
                            </div>

                            <div className="landingpage__feature-grid">
                                {featureItems.map((item) => (
                                    <article key={item.title} className="landingpage__feature-card">
                                        <div className="landingpage__feature-icon">{item.icon}</div>
                                        <Typography component="h3" className="landingpage__feature-title">
                                            {item.title}
                                        </Typography>
                                        <Typography component="p" className="landingpage__feature-copy">
                                            {item.description}
                                        </Typography>
                                    </article>
                                ))}
                            </div>

                            <div className="landingpage__footer-cta">
                                <Button
                                    variant="contained"
                                    startIcon={<FavoriteRoundedIcon />}
                                    className="landingpage__primary-button landingpage__footer-button"
                                    onClick={() => {
                                        history.push(REGISTER_USER);
                                    }}
                                >
                                    Jetzt kostenlos registrieren
                                </Button>

                                <Button
                                    variant="contained"
                                    className="landingpage__secondary-button landingpage__footer-button"
                                    onClick={() => {
                                        history.push(LOGIN_PATH);
                                    }}
                                >
                                    Schon Mitglied? Einloggen
                                </Button>
                            </div>
                        </div>
                    </section>
                </main>

                <footer className="landingpage__footer">
                    <div className="landingpage__shell landingpage__footer-inner">
                        <Link to="/support" className="landingpage__footer-link">
                            Kontakt
                        </Link>
                        <Link to="/impressum" className="landingpage__footer-link">
                            Impressum
                        </Link>
                        <Link to="/datenschutz" className="landingpage__footer-link">
                            Datenschutz
                        </Link>
                        <Link to="/agb" className="landingpage__footer-link">
                            AGB
                        </Link>
                        <Link to="/content-guidelines" className="landingpage__footer-link">
                            Content &amp; Community Guidelines
                        </Link>
                    </div>
                    <p className="landingpage__legal-copy">
                        Diese Webseite darf ausschlie&szlig;lich von Personen genutzt werden, die mindestens 18 Jahre alt sind. Die Plattform stellt
                        einen virtuellen Chat-Dienst f&uuml;r unterhaltsame, flirtende und fantasievolle Gespr&auml;che zur Verf&uuml;gung. Hierbei
                        werden fiktive Profile verwendet, mit denen keine pers&ouml;nlichen oder realen Treffen m&ouml;glich sind. Die Kosten je
                        Nachricht k&ouml;nnen je nach gew&auml;hlter Zahlungsart unterschiedlich ausfallen. Bitte informieren Sie sich vor der Nutzung
                        der Webseite &uuml;ber die geltenden Nutzungsbedingungen und Datenschutzbestimmungen.
                    </p>
                </footer>

                <Route path={REGISTER_PATH} exact render={() => <Redirect to={REGISTER_USER} />} />
                <Route
                    path={LOGIN_PATH}
                    exact
                    render={() => (
                        <LoginModal
                            open
                            onClose={() => {
                                history.push(MAIN_PATH);
                            }}
                        />
                    )}
                />
                <Route
                    path="/__legacy-login-luvioo"
                    exact
                    render={() => (
                        <Dialog
                            open
                            onClose={() => {
                                history.push(MAIN_PATH);
                            }}
                            maxWidth="sm"
                            fullWidth
                            PaperProps={{ className: 'landingpage__auth-paper' }}
                        >
                            <IconButton
                                className="landingpage__auth-close"
                                onClick={() => {
                                    history.push(MAIN_PATH);
                                }}
                                aria-label="Schließen"
                            >
                                <CloseRoundedIcon />
                            </IconButton>
                            <div className="landingpage__auth-content">
                                <SignInComponent
                                    handleNextStep={() => {
                                        history.push(REGISTER_USER);
                                    }}
                                />
                            </div>
                        </Dialog>
                    )}
                />
                <Route path={FORGOT_PASSWORD_PATH} exact render={() => <ForgotPasswordModal open />} />
                <Route path={FORGOT_PASSWORD_PATHH} exact render={() => <ForgotPasswordModalx />} />
            </div>
        </ThemeProvider>
    );
});

export default Landingpage;
